import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  OverviewReportApiResponse,
  QuickSightDashboardPayload,
  QuickSightDashboardsApiResponse,
  RemovedUserReportApiResponse,
} from '@core/models';
import { environment as env } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http = inject(HttpClient);

  private baseUrl = `${env.apiURL}api/v1`;
  private reportsUrl = `${this.baseUrl}/reports`;
  private dashboardsUrl = `${this.baseUrl}/dashboard/quicksight`;

  public getDashboards(): Observable<QuickSightDashboardsApiResponse> {
    return this.http.get<QuickSightDashboardsApiResponse>(this.dashboardsUrl);
  }

  public getOverviewReport(): Observable<OverviewReportApiResponse> {
    return this.http.get<OverviewReportApiResponse>(
      `${this.reportsUrl}/submissions`,
    );
  }

  public getRemovedUserReport(): Observable<RemovedUserReportApiResponse> {
    return this.http.get<RemovedUserReportApiResponse>(
      `${this.reportsUrl}/removed-users`,
    );
  }

  public updateDashboard(
    payload: QuickSightDashboardPayload,
  ): Observable<QuickSightDashboardsApiResponse> {
    return this.http.put<QuickSightDashboardsApiResponse>(
      this.dashboardsUrl,
      payload,
    );
  }
}
